export const UPDATE_ACTIVE_PORTFOLIO = "NEW_UPDATE_ACTIVE_PORTFOLIO";
export const SWITCH_ACTIVE_PORTFOLIO = "NEW_SWITCH_ACTIVE_PORTFOLIO";
export const ADD_OR_UPDATE_ACTIVE_PORTFOLIO_CONTACT = "NEW_ADD_OR_UPDATE_ACTIVE_PORTFOLIO_CONTACT";
export const REMOVE_ACTIVE_PORTFOLIO_CONTACT = "NEW_REMOVE_ACTIVE_PORTFOLIO_CONTACT";
export const UPDATE_ACTIVE_PORTFOLIO_LIFECHECK = "NEW_UPDATE_ACTIVE_PORTFOLIO_LIFECHECK";
